import { cpf } from 'cpf-cnpj-validator';
import { createMask } from 'imask';
import React, { ChangeEvent, useCallback } from 'react';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import { useForm } from 'react-hook-form';
import { useSteps } from '../../contexts/stepContext';
import { useAppTranslation } from '../../hooks/useAppTranslation';
import { Title } from '../../styles/global';
import { errorToast } from '../../utils/toast';
import { Content, GoBack } from '../BodyStep/styles';
import Button from '../Button';
import DropDown from '../DropDown';
import Input from '../Input';
import { FormContent } from './styles';

const maskCpf = createMask({
  mask: '000.000.000-00',
});

const maskBirth = createMask({
  mask: '00/00/0000',
});

const Identification: React.FC = () => {
  const {
    handleChangeCurrentStep,
    documentNum,
    name,
    birthday,
    documentType,
    handleSetDocument,
    handleSetName,
    handleSetBirthday,
    handleReturnCurrentStep,
    setDocumentType,
    documents,
  } = useSteps();

  const { handleSubmit } = useForm();
  const { translationPage } = useAppTranslation();
  const { tp } = translationPage(tr => tr.components.identification);

  const handleValidate = useCallback(() => {
    if (name === '') {
      errorToast({ message: tp('nameRequired') });
      return;
    }

    if (birthday === '') {
      errorToast({ message: tp('birthRequired') });
      return;
    }

    if (documentType === 1 || documentType === 0) {
      if (!cpf.isValid(documentNum)) {
        errorToast({ message: tp('documentInvalid') });
        return;
      }
      handleChangeCurrentStep();
      return;
    }
    handleChangeCurrentStep();
  }, [birthday, documentNum, documentType, handleChangeCurrentStep, name, tp]);

  const setCpf = (e: ChangeEvent<HTMLInputElement>) => {
    e.target.value = maskCpf.resolve(e.target.value);
    handleSetDocument(e.target.value);
  };

  const setBirth = (e: ChangeEvent<HTMLInputElement>) => {
    e.target.value = maskBirth.resolve(e.target.value);
    handleSetBirthday(e.target.value);
  };

  return (
    <Content>
      <GoBack onClick={handleReturnCurrentStep}>
        <FaArrowLeft size={16} />
        {tp('back')}
      </GoBack>
      <Title>{tp('title')}</Title>
      <FormContent onSubmit={handleSubmit(handleValidate)}>
        <Input
          type="text"
          label={tp('nameLabel')}
          onChange={e => handleSetName(e.target.value)}
          value={name}
          width="70%"
          autoFocus
        />
        <Input
          type="tel"
          label={tp('birthLabel')}
          onChange={e => setBirth(e)}
          value={birthday}
          width="40%"
        />

        <DropDown
          label={tp('documentTypeLabel')}
          options={documents}
          onChange={e => {
            setDocumentType(Number(e.target.value));
          }}
          width="40%"
        />
        <Input
          type="tel"
          label={tp('documentNumberLabel')}
          onChange={e =>
            documentType === 1 ? setCpf(e) : handleSetDocument(e.target.value)
          }
          value={documentNum}
          disabled={documentType === 0}
          width="40%"
        />
        <Button title={tp('next')} type="submit" icon={FaArrowRight} />
      </FormContent>
    </Content>
  );
};

export default Identification;
